import { Component, OnDestroy, OnInit } from "@angular/core";
import { EquipmentService } from "src/app/services/equipment.service";
import { Subscription } from "rxjs";
import { CompanyService } from "../../../services";
import { Router } from "@angular/router";
import { SessionDataService } from "src/app/services/session-data.service";
@Component({
    selector: "app-equipment-list",
    templateUrl: "./equipment-list.component.html",
    styleUrls: ["./equipment-list.component.scss"]
})
export class EquipmentListComponent implements OnInit, OnDestroy
{

    title: string = "";
    companySubscription: Subscription;
    isEmployee: boolean = false;

    constructor(
        public equipmentService: EquipmentService,
        private companyService: CompanyService,
        private sessionDataService: SessionDataService,
        private router: Router

    ) { }
    ngOnInit(): void
    {
        this.isEmployee = this.sessionDataService.IsEmployee;

        this.companySubscription = this.companyService.company.subscribe(c =>
        {
            // in case user somehow has url, but company prevents them from seeing equip, user
            // is sent to not-found error pg.
            if (c.WebDisplayEquipment === false && this.isEmployee == false)
            {
                this.router.navigate(["/not-found"]);
            }
        });
    }
    ngOnDestroy()
    {
        this.companySubscription.unsubscribe();
    }
}
